import PlayingChild from './../assets/img/playing_children-new.jpg'
import HidingChild from './../assets/img/children_hiding-new.jpg'
import TwoBrothers from './../assets/img/two_brothers_img.webp'
import ComputerImg from './../assets/img/event_frame.webp'
import CarouselImg1 from './../assets/img/carousel_bg-new.jpg'
import CarouselImg2 from './../assets/img/carousel_bg2-new.jpg'
import CarouselImg3 from './../assets/img/carousel_bg3-new.jpg'
import GirlImage from './../assets/img/girl_image-new.png'
import PencilBag from './../assets/img/pencil_bag-new.png'
import ExploreServiceFrame from './../assets/img/service_frame-new.png'
import HeroSectionImg from './../assets/img/hero_section_imgwebp.webp'
import SkillBoxImg from './../assets/img/skillBoxImg.png'
import HeroSectionImgJpg from './../assets/img/hero_sectionsm_webp.webp'
import Unio1 from './../assets/img/Union3.svg'
import Unio2 from './../assets/img/Union2.svg'
import LocationImg from './../assets/img/location_img-new.png'
import CourseDetailImg1 from './../assets/img/course_detail_img1webp.webp'
import CourseDetailImg2 from './../assets/img/course_detail_img2webp.webp'
import UserAvatar from './../assets/img/user_avatarwebp.webp'
import TextBgImg from './../assets/img/text_background_img-new.jpg'
import CourseImg from './../assets/img/course_frame.webp'
import AddImg from './../assets/img/add_imgwebp.webp'
import GrainLeft from './../assets/img/grain_left-new.png'
import GrainRight from './../assets/img/grain_right-new.png'
import AddImgBg from './../assets/img/Featured_addwebp.webp'
import Logo from './../assets/img/pedaskills_logo.png'
import WhiteSpace from './../assets/img/white_space.svg'
import SidebarImg from './../assets/img/sidebar_imgweb.webp'
import SiblingPlaying from './../assets/img/siblings_playing.svg'
import WelcomeImg from './../assets/img/welcome_img2.webp'
import CompletedImg from './../assets/img/completed_img.webp'
import CashBackImg from './../assets/img/man_with_coin.svg'
import CampsHeroImg from './../assets/img/camp_hero_sec.svg'
import CampWord from './../assets/img/Camp_Word.svg'
import CampWord1 from './../assets/img/camp_word1.svg'
import CampBg from './../assets/img/camp_bg_img.svg'
import SheInspreBanner from './../assets/img/she_inspire_banner.svg'
import SheInspireFrame1 from './../assets/img/she_inspire_frame1-new.jpg'
import SheInspireFrame2 from './../assets/img/she_inspire_frame2-new.jpg'
import SheInspireFrame3 from './../assets/img/she_inspire_frame3-new.jpg'
import StarIconFram1 from './../assets/img/star_icon_fram1-new.jpg'
import StarIconFram2 from './../assets/img/star_icon_fram2-new.jpg'
import StarIconFram3 from './../assets/img/star_icon_fram3-new.jpg'
import AwardOne from './../assets/img/Award1.svg'
import AwardTwo from './../assets/img/Award2.svg'
import AwardThree from './../assets/img/Award3.svg'
import SheInspireImg from './../assets/img/she_inspire_bg.svg'
import ApartmentOnboaFram from './../assets/img/apartment_bg_frame.svg'
import ApartmentConnect from './../assets/img/apartment_onboarding_arrow.png'
import ApartmentConnectWithContent from './../assets/img/apartment_onboard_arrowwithcontent.png'
import QuestionLady from './../assets/img/Question_lady.svg'
import KnowMoreSec from './../assets/img/know_more_img-new.png'
import CampConnector from './../assets/img/camp_connector.svg'
import ApartmentOnbaordIn from './../assets/img/apartement_onbaord_individual.svg'
import InfoGraphic from './../assets/img/infographic.svg'
import PurchasedImg from './../assets/img/PurchasedCourse-new.png'
import PurchasedSprint from './../assets/img/PurchasedSprints-new.jpg'
import AboutUsFrame1 from './../assets/img/about-us-frame1-new.png'
import AboutUsFrame2 from './../assets/img/about-us-frame2-new.png'
import ImpCurriculum from './../assets/img/imp-curriculum-new.png'
import OurApproach from './../assets/img/out-approach-new.png'
import LearningOutcome from './../assets/img/learning-outcome-new.png'
import ExpertiseExperience from './../assets/img/expertise-experience-new.png'
import DominoHeroImg from './../assets/img/domino-hero-img-new.png'
import DominoBrick from './../assets/img/domino-brick-new.png'
import BlockPuttingHand from './../assets/img/block-puting-hand-new.png'
import DominoWhiteBg from './../assets/img/domino-white-bg-new.png'
import PrizeOneImg from './../assets/img/prize-one-img-new.jpg'
import PrizeTowImg from './../assets/img/prize-two-im-new.jpg'
import PrizeThreeImg from './../assets/img/prize-three-img-new.jpg'
import FirstPrize from './../assets/img/first-prize-new.png'
import SecondPrize from './../assets/img/second-prize-new.png'
import ThirdPrize from './../assets/img/third-prize-new.png'
import ArrowMark from './../assets/img/arrow-mark.png'
import ArrowMarkLight from './../assets/img/light-arrow.png'
import DominoLightBlocks from './../assets/img/domino-light-img-new.png'
import DominoRulesCardImg from './../assets/img/domino-rules-card-img-new.png'
import DominoRuleTopSection from './../assets/img/domino-rule-top-img-new.png'
import ParticipantsImg from './../assets/img/participants_img-new.jpg'
import AuthBgImg from './../assets/img/authimg-new.jpg'
import DominoBoys from './../assets/img/domino-boys-new.png'
import DominoFallBg from './../assets/img/leaderBoard/domino-fall-new.jpg'
import PollingBg from './../assets/img/leaderBoard/polling-new.jpg'
import BaloonGarlandBg from './../assets/img/leaderBoard/baloorn-garland-new.jpg'
import PollingImgFrame1 from './../assets/img/leaderBoard/pollingImgFrame1-new.jpg'
import PollingImgFrame2 from './../assets/img/leaderBoard/pollingImgFrame2-new.jpg'
import PollingImgFrame3 from './../assets/img/leaderBoard/pollingImgFrame3-new.jpg'
import PollingImgFrame4 from './../assets/img/leaderBoard/pollingImgFrame4-new.jpg'
import PollingImgFrame5 from './../assets/img/leaderBoard/pollingImgFrame5-new.jpg'
import pollingHeroImg from './../assets/img/leaderBoard/pollingHeroImg-new.jpg'
import ResultCandidateImg from './../assets/img/leaderBoard/resultCandidateImg-new.jpg'
import ResultShirtImg from './../assets/img/leaderBoard/resultShirtImg-new.png'
import CompetitionCaraouselImg1 from './../assets/img/leaderBoard/competitionCaraouselImg1-new.jpg'
import CompetitionCaraouselImg2 from './../assets/img/leaderBoard/competitionCaraouselImg2-new.jpg'
import HeroCaraouselImg2 from './../assets/img/hero-caraousel2.svg'
import SkillBoxHeroImg from './../assets/img/skillboxheadimg.png'
import SkillBoxHeadingImg from './../assets/img/SkillBoxHeadingBg.png'
import SkillBoxFrame1 from './../assets/img/SkillBoxFrame1.png'
import SkillBoxFrame2 from './../assets/img/SkillBoxFrame2.png'
import ForChildren from './../assets/img/forchildren.jpg'
import ForSchool from './../assets/img/preschool.jpg'
import ForParent from './../assets/img/forparent.jpg'
import ForTeacher from './../assets/img/forteacher.jpg'
import SkillBoxConnectingWire from './../assets/img/skillboxconnectingwire.png'
import CourseDetailFrame2 from './../assets/img/course-detailframe2.jpg'
import CourseDetailFrame3 from './../assets/img/course-detailframe3.jpg'
import StartBullet from './../assets/img/Starbullet.png'
import SafeConvenient from './../assets/img/apartmentOnboard/safe_convient.png'
import EmpoweringParent from './../assets/img/apartmentOnboard/empowering_parent.png'
import NoCommutHassle from './../assets/img/apartmentOnboard/no_commut_hassle.png'
import NurturingMind from './../assets/img/apartmentOnboard/nurturing_young_mind.png'
import BuildingFriendship from './../assets/img/apartmentOnboard/building_friendship.png'
import SheInspireHeroImgSm from './../assets/img/sheInspireHeroImgSm.png'


export class Constants {
  static customImages = {
    PlayingChild,
    HidingChild,
    TwoBrothers,
    ComputerImg,
    CarouselImg1,
    CarouselImg2,
    CarouselImg3,
    GirlImage,
    PencilBag,
    ExploreServiceFrame,
    HeroSectionImg,
    SkillBoxImg,
    Unio1,
    Unio2,
    LocationImg,
    CourseDetailImg1,
    CourseDetailImg2,
    UserAvatar,
    TextBgImg,
    CourseImg,
    AddImg,
    GrainRight,
    GrainLeft,
    AddImgBg,
    Logo,
    WhiteSpace,
    HeroSectionImgJpg,
    SidebarImg,
    SiblingPlaying,
    WelcomeImg,
    CompletedImg,
    CashBackImg,
    CampsHeroImg,
    CampWord,
    CampBg,
    SheInspreBanner,
    SheInspireFrame1,
    SheInspireFrame2,
    SheInspireFrame3,
    StarIconFram1,
    StarIconFram2,
    StarIconFram3,
    AwardOne,
    AwardTwo,
    AwardThree,
    SheInspireImg,
    ApartmentOnboaFram,
    ApartmentConnect,
    QuestionLady,
    KnowMoreSec,
    CampConnector,
    CampWord1,
    ApartmentOnbaordIn,
    InfoGraphic,
    PurchasedImg,
    PurchasedSprint,
    AboutUsFrame1,
    AboutUsFrame2,
    ImpCurriculum,
    OurApproach,
    LearningOutcome,
    ExpertiseExperience,
    DominoHeroImg,
    DominoBrick,
    BlockPuttingHand,
    DominoWhiteBg,
    PrizeOneImg,
    PrizeTowImg,
    PrizeThreeImg,
    FirstPrize,
    SecondPrize,
    ThirdPrize,
    ArrowMark,
    DominoLightBlocks,
    DominoRulesCardImg,
    DominoRuleTopSection,
    ParticipantsImg,
    DominoBoys,
    ArrowMarkLight,
    AuthBgImg,
    BaloonGarlandBg,
    DominoFallBg,
    PollingBg,
    PollingImgFrame1,
    PollingImgFrame2,
    PollingImgFrame3,
    PollingImgFrame4,
    PollingImgFrame5,
    pollingHeroImg,
    ResultShirtImg,
    ResultCandidateImg,
    CompetitionCaraouselImg1,
    CompetitionCaraouselImg2,
    HeroCaraouselImg2,
    SkillBoxHeroImg,
    SkillBoxHeadingImg,
    SkillBoxFrame1,
    SkillBoxFrame2,
    ForChildren,
    ForParent,
    ForSchool,
    ForTeacher,
    SkillBoxConnectingWire,
    CourseDetailFrame2,
    CourseDetailFrame3,
    StartBullet,
    SafeConvenient,
    NurturingMind,
    EmpoweringParent,
    NoCommutHassle,
    BuildingFriendship,
    SheInspireHeroImgSm,
    ApartmentConnectWithContent
  };
}

export const URL = `https://myskill.club/studentdashboard/student/dashboard`

export const BOX_SHADOW = "0px 8px 16px 0px #00000040"

export const Path = '/web'
export const DividerBorder = "1px solid #D9D9D9"

export const Page_Padding = { xs: "20px", sm: "30px", md: "80px" };

export const Card_Width = { xs: "300px", lg: "340px" };


export const Dashboard_URL = window._env_?.REDIRECT_URL || ""
export const Skillvation_Dashboard_URL = window._env_?.SKILLVATION_DASHBOARD_URL || ""
export const Domain = window._env_?.DOMAIN || ""

export const Website_Url = window._env_?.WEBSITE_URL || ""

export const Main_URL = window._env_?.WEBSITE_PATH_SHOP_TIMES

export const ImagePath = window._env_?.IMAGE_PATH || ""

export const ProSkillUrl = window._env_?.WEBSITE_PATH_PRO


export const apiUrlShop = window._env_?.API_PATH_SHOP;

export const apiUrlNode = window._env_?.API_PATH_NODE;

export const CaptchaKey = window._env_?.CAPTCHA_KEY;

export const ImagePathNode = window._env_?.IMAGE_PATH_NODE;


export const ImageRelativePath = "assets/images/event/cover/"

export const DEFAULT_STALE_TIME = 300000;
export const DEFAULT_CACHE_TIME = 600000;

// SSO Configuration
const CLIENT_ID_MAP = {
  'localhost:3000': 'CLIENT_ID_3000',
  'localhost:3001': 'CLIENT_ID_3001',
  'dev.pedaskills.com': 'CLIENT_ID_PROD',
};

const currentHost = 'pedaskill';
const currentOrigin = window.location.origin;

export const ssoBaseUrl = window._env_?.SSO_BASE_URL || "http://localhost:5173";
export const ssoClientId = CLIENT_ID_MAP[currentHost] || window._env_?.SSO_CLIENT_ID;
export const ssoClientSecret = window._env_?.SSO_CLIENT_SECRET || "";
export const ssoApiUrl = window._env_?.SSO_API_URL || "http://localhost:4000/api/v1/auth/sso-login";
export const ssoRedirectUri = encodeURIComponent(`${currentOrigin}/callback`);

const generateRandomState = (length = 16) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

export const ssoLoginUrl =
  `${ssoBaseUrl}` +
  `?client_id=${ssoClientId}` +
  `&redirect_uri=${ssoRedirectUri}` +
  `&state=${generateRandomState()}`;

export const ssoLogoutUrl = `${ssoBaseUrl}/logout?logout=true&client_id=${ssoClientId}&redirect_uri=${ssoRedirectUri}`;

